module.exports = __webpack_public_path__ + "img/phone-icon.180651e4.svg";